export default "__VITE_ASSET__BSwVoEg___"